// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5773":"f7ec5635","7132":"f7ec5635"}[chunkId] + ".chunk.css";
};